document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('simulatorModal');
    if (!modal) return;

    const densite = parseFloat(modal.dataset.densite) || 1.5;
    let currentTarif = parseFloat(modal.dataset.minTarif) || 0;

    const lengthInput = document.getElementById('length');
    const widthInput = document.getElementById('width');
    const thicknessInput = document.getElementById('thickness');

    const resultSurface = document.getElementById('result-surface');
    const resultVolume = document.getElementById('result-volume');
    const resultTonnage = document.getElementById('result-tonnage');
    const resultPrice = document.getElementById('result-price');

    function formatNumber(value, decimals = 2) {
        return value.toLocaleString('fr-FR', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    function calculate() {
        const length = parseFloat(lengthInput.value) || 0;
        const width = parseFloat(widthInput.value) || 0;
        const thickness = parseFloat(thicknessInput.value) || 0;

        // Surface = longueur x largeur (m²)
        const surface = length * width;

        // Volume = longueur x largeur x épaisseur (épaisseur en cm, donc /100 pour m³)
        const volume = length * width * (thickness / 100);

        // Tonnage = volume x densité
        const tonnage = volume * densite;

        // Prix HT = tonnage x tarif du dépôt sélectionné
        const price = tonnage * currentTarif;

        resultSurface.textContent = formatNumber(surface);
        resultVolume.textContent = formatNumber(volume);
        resultTonnage.innerHTML = formatNumber(tonnage);

        if (resultPrice) {
            resultPrice.textContent = formatNumber(price);
        }
    }

    // Écouter le changement de prix quand un dépôt est sélectionné
    document.addEventListener('depotPriceChanged', (e) => {
        currentTarif = e.detail.price;
        modal.dataset.minTarif = e.detail.price; // ← persiste pour la réouverture
        calculate();
    });

    [lengthInput, widthInput, thicknessInput].forEach(input => {
        if (input) {
            input.addEventListener('input', calculate);
        }
    });

    // Calcul initial
    calculate();
});
